import { type ReactNode, Suspense } from 'react';
import InitialLoadingPage from '../../pages/LoadingPage/InitialLoadingPage';
import { removeInitialLoadingElement } from '../../pages/LoadingPage/initialLoadingElement';

type AppContentLoadingBoundaryProps = {
  children: ReactNode;
};

function handleContentCommit(element: HTMLDivElement | null) {
  if (element) removeInitialLoadingElement();
}

function AppContentLoadingBoundary({ children }: AppContentLoadingBoundaryProps) {
  return (
    <Suspense fallback={<InitialLoadingPage pageLoadingClassName='h-full' />}>
      <div ref={handleContentCommit} className='contents'>
        {children}
      </div>
    </Suspense>
  );
}

export default AppContentLoadingBoundary;
